/* =====================================================================
   AmpBird Blog Article — lightweight Table of Contents
   - Scans article content for <h2> headings
   - Injects stable ids (progressive enhancement; content works without JS)
   - Builds desktop sticky TOC + mobile collapsible TOC
   - Highlights the current section on scroll via IntersectionObserver
   No third-party dependencies.
   ===================================================================== */
(function () {
  'use strict';

  function slugify(text, index) {
    var base = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    if (!base) {
      base = 'section';
    }
    return 'abx-' + base + '-' + index;
  }

  function initArticle(root) {
    var content = root.querySelector('[data-abx-content]');
    if (!content) return;

    var headings = content.querySelectorAll('h2');
    var tocDesktop = root.querySelector('[data-abx-toc-list]');
    var tocMobile = root.querySelector('[data-abx-toc-mobile-list]');
    var tocWrapDesktop = root.querySelector('[data-abx-toc]');
    var tocWrapMobile = root.querySelector('[data-abx-toc-mobile]');

    // Hide TOC when there are fewer than 3 headings (not useful enough)
    var MIN_TOC = 3;
    if (headings.length < MIN_TOC) {
      if (tocWrapDesktop) tocWrapDesktop.style.display = 'none';
      if (tocWrapMobile) tocWrapMobile.style.display = 'none';
      return;
    }

    var links = [];
    var idMap = {};

    headings.forEach(function (h, i) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent, i);
        // ensure uniqueness
        var unique = id;
        var n = 1;
        while (document.getElementById(unique)) {
          unique = id + '-' + n;
          n++;
        }
        id = unique;
        h.id = id;
      }

      var text = h.textContent.trim();

      if (tocDesktop) {
        var li = document.createElement('li');
        li.className = 'abx-toc__item';
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = text;
        li.appendChild(a);
        tocDesktop.appendChild(li);
        links.push({ id: id, el: li });
        idMap[id] = li;
      }

      if (tocMobile) {
        var liM = document.createElement('li');
        var aM = document.createElement('a');
        aM.href = '#' + id;
        aM.textContent = text;
        liM.appendChild(aM);
        tocMobile.appendChild(liM);
      }
    });

    // Close the mobile <details> after a link is tapped
    if (tocWrapMobile) {
      var details = tocWrapMobile.querySelector('details');
      if (details) {
        tocWrapMobile.addEventListener('click', function (e) {
          if (e.target.tagName === 'A') {
            details.open = false;
          }
        });
      }
    }

    // Scroll highlight
    if (links.length && 'IntersectionObserver' in window) {
      var current = null;

      var setActive = function (id) {
        if (current === id) return;
        current = id;
        links.forEach(function (l) {
          if (l.id === id) {
            l.el.classList.add('is-active');
          } else {
            l.el.classList.remove('is-active');
          }
        });
      };

      var observer = new IntersectionObserver(
        function (entries) {
          // pick the topmost heading that is intersecting
          var visible = entries
            .filter(function (en) { return en.isIntersecting; })
            .sort(function (a, b) {
              return a.boundingClientRect.top - b.boundingClientRect.top;
            });
          if (visible.length) {
            setActive(visible[0].target.id);
          }
        },
        { rootMargin: '-90px 0px -70% 0px', threshold: 0 }
      );

      headings.forEach(function (h) { observer.observe(h); });

      // activate first by default
      setActive(headings[0].id);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-abx-article]');
    roots.forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
